import React from "react";
import Slider from "react-slick";
import SliderImage from '../../assets/images/login_signup_slider_img.svg';
import '../Slider/slider.scss';

export default function SimpleSlider() {
    var settings = {
        dots: true,
        infinite: true,
        arrows: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
    };
    return (
        <Slider {...settings}>
            <div>
                <div className="slider-img-div">
                    <img className="sliderImage" src={SliderImage} alt="" />
                </div>
                <div className="slider-caption-div">
                    <h2>Create a list of target accounts</h2>
                    <p>Input the company name and URL of your dream clients - this is account based marketing, so aim high.</p>
                </div>
            </div>
            <div>
                <div className="slider-img-div">
                    <img className="sliderImage" src={SliderImage} alt="" />
                </div>
                <div className="slider-caption-div">
                    <h2>Create a list of target accounts</h2>
                    <p>Input the company name and URL of your dream clients - this is account based marketing, so aim high.</p>
                </div>
            </div>
            <div>
                <div className="slider-img-div">
                    <img className="sliderImage" src={SliderImage} alt="" />
                </div>
                <div className="slider-caption-div">
                    <h2>Create a list of target accounts</h2>
                    <p>Input the company name and URL of your dream clients - this is account based marketing, so aim high.</p>
                </div>
            </div>
            <div>
                <div className="slider-img-div">
                    <img className="sliderImage" src={SliderImage} alt="" />
                </div>
                <div className="slider-caption-div">
                    <h2>Create a list of target accounts</h2>
                    <p>Input the company name and URL of your dream clients - this is account based marketing, so aim high.</p>
                </div>
            </div>
        </Slider>
    );
}